export default __webpack_public_path__ + "static/media/file-structure.aea39226.svg";